/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
  Snackbar,
  Alert as MuiAlert
} from '@mui/material';
import { SignatureCanvas } from 'components/assinatura/SignatureCanvas';
import { Header } from 'components/home';
import { SimpleArcGISMap } from 'components/map';
import { ContainerForm } from 'components/shared/container_form';
import InputComLabelFormik from 'components/shared/custom_input_label_formik';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { validationSchemaAssinatura } from './validationScheema';
import {
  CoordinateCaptureMethodEnum as _CoordinateCaptureMethodEnum,
  decimalMask as _decimalMask,
  toStrOr,
  normalizeMethod,
  extractUuidFromSigPayload,
  coordsOk as coordsOkHelper,
  isSignatureFilled as isSignatureFilledHelper,
} from './helpers';
import { CuffaAPI } from 'api/cuffa/cuffa.api';
import { useCuffaStore } from 'stores/cuffa/cuffa.store'
import { ROUTES } from 'routes/constants';


const CoordinateCaptureMethodEnum = _CoordinateCaptureMethodEnum;
const decimalMask = _decimalMask;


type SigPayload = string | { uuid?: string | null; name?: string } | null | undefined;




export const AssinaturaCuffaIncluir: React.FC = () => {
  const navigate = useNavigate();
  const { uuid } = useParams<{ uuid: string }>();

  const [initialLocationLoaded, setInitialLocationLoaded] = useState(false);
  const [confirmBusy, setConfirmBusy] = useState(false);
  const { dadosParciais, setCollectionUuid, salvarDadosParciais } = useCuffaStore();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [nextRoute, setNextRoute] = useState<string | null>(null);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [snack, setSnack] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'info' | 'warning' }>({
    open: false, message: '', severity: 'success'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  // pegue o uuid do store, além do da URL
  const storeUuid = useCuffaStore.getState().collectionUuid;
  const currentUuid = uuid ?? storeUuid ?? null;


  const formik = useFormik({
    initialValues: {
      signature_uuid: '',
      latitude: '-15.5597',
      longitude: '-56.0354',
      coordinate_capture_method: CoordinateCaptureMethodEnum.AUTOMATIC
    },
    validationSchema: validationSchemaAssinatura,
    onSubmit: async (values) => {
      setIsSubmitting(true);
      try {
        // Logs de depuração
        const lat = parseFloat(String(values.latitude).replace(',', '.'));
        const lng = parseFloat(String(values.longitude).replace(',', '.'));
        console.log('[Submit] signature_uuid:', values.signature_uuid);
        console.log('[Submit] Coords:', lat, lng);
        console.log('[Submit] currentUuid:', currentUuid);

        // Guarda de segurança
        if (!currentUuid) {
          setErrorMessage('UUID é obrigatório para enviar a assinatura.');
          setShowErrorDialog(true);
          return;
        }

        // Monta payload no formato esperado pelo backend
        const signaturePayload = {
          signature_uuid: values.signature_uuid,
          latitude: lat,
          longitude: lng,
          coordinate_capture_method: values.coordinate_capture_method as 'AUTOMATIC' | 'MANUAL',
        };

        // 1) Envia/atualiza a assinatura (PATCH)
        const respSig = await CuffaAPI.sendSignature(currentUuid, signaturePayload);
        console.log('[sendSignature] response:', respSig);

        if (respSig?.Status === 'ERRO') {
          setErrorMessage(respSig?.Mensagem ?? 'Erro ao enviar assinatura. Tente novamente.');
          setShowErrorDialog(true);
          return;
        }

        // 2) Valida e cadastra a coleta (PUT)
        setSnack({ open: true, message: 'Assinatura enviada. Cadastrando coleta…', severity: 'info' });

        const respFinal = await CuffaAPI.validateAndCreate(currentUuid);
        console.log('[validateAndCreate] response:', respFinal);

        if (respFinal?.Status === 'ERRO') {
          setErrorMessage(respFinal?.Mensagem ?? 'Erro ao cadastrar coleta.');
          setShowErrorDialog(true);
          return;
        }

        // Sucesso
        setShowSuccessDialog(true);
      } catch (error: any) {
        console.error('[Submit] Erro geral no envio:', error);
        setErrorMessage(
          error?.response?.data?.Mensagem ||
          error?.response?.data?.message ||
          error?.message ||
          'Erro ao enviar formulário. Tente novamente.'
        );
        setShowErrorDialog(true);
      } finally {
        setIsSubmitting(false);
      }
    }


  });



  const latNum = Number(formik.values.latitude);
  const lngNum = Number(formik.values.longitude);
  const haveCoords = Number.isFinite(latNum) && Number.isFinite(lngNum);

  const isSignatureFilled = isSignatureFilledHelper(formik.values.signature_uuid);

  const coordsOk = coordsOkHelper(
    formik.values.coordinate_capture_method,
    String(formik.values.latitude),
    String(formik.values.longitude)
  );

  const isSubmitDisabled = isSubmitting || !isSignatureFilled || !coordsOk;



  const handleSignatureUuidChange = (payload: SigPayload) => {
    console.log('[Signature] payload recebido:', payload);
    const id = extractUuidFromSigPayload(payload);
    console.log('[Signature] uuid extraído:', id);
    formik.setFieldValue('signature_uuid', id, true);
    formik.setFieldTouched('signature_uuid', true, false);
  };


  const handleCoordinateMethodChange = (method: string) => {
    formik.setFieldValue('coordinate_capture_method', method);
    if (method === CoordinateCaptureMethodEnum.AUTOMATIC) {
      getLocation();
    }
  };

  const getLocation = () => {
    if (!navigator.geolocation) {
      console.log('Geolocalização não é suportada pelo navegador');
      return;
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0
    };

    const onSuccess = (position: GeolocationPosition) => {
      formik.setFieldValue('latitude', String(position.coords.latitude));
      formik.setFieldValue('longitude', String(position.coords.longitude));
      setInitialLocationLoaded(true);
    };


    const onError = (error: GeolocationPositionError) => {
      console.error('Erro ao obter localização:', error.message);
      alert('Não conseguimos acessar sua localização. Tente novamente.');
      setInitialLocationLoaded(true);
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(onSuccess, onError, options);
    } else {
      alert('A geolocalização não é suportada neste navegador.');
    }

  };

  const openSnack = (message: string, severity: 'success' | 'error' | 'info' | 'warning' = 'success') =>
    setSnack({ open: true, message, severity });





  const handleSubmitForm = async () => {
    if (isSubmitting) return;

    const errors = await formik.validateForm();
    if (Object.keys(errors).length) {
      Object.keys(errors).forEach((k) => {
        formik.setFieldTouched(k as any, true, false);
      });
      setSnack({ open: true, message: 'Preencha os campos obrigatórios.', severity: 'error' });
      return;
    }

    setShowConfirmDialog(true);
  };




  const handleSnackClose = (_?: any, reason?: string) => {
    if (reason === 'clickaway') return;
    setSnack(s => ({ ...s, open: false }));
    if (nextRoute) {
      const r = nextRoute;
      setNextRoute(null);
      navigate(r);
    }
  };



  const confirmSubmit = async () => {
    try {
      setConfirmBusy(true);
      await formik.submitForm();
      setShowConfirmDialog(false);
    } finally {
      setConfirmBusy(false);
    }
  };

  // using helpers: toStrOr, normalizeMethod



  const handleSaveDraft = () => {
    salvarDadosParciais({ assinaturaCuffa: formik.values });
    openSnack('Rascunho salvo com sucesso', 'success');
    setTimeout(() => navigate(ROUTES.CUFFA), 1200);
  };




  useEffect(() => {
    if (uuid) setCollectionUuid(uuid);

    const draft = dadosParciais?.assinaturaCuffa;
    if (!draft) {
      getLocation();
      return;
    }

    formik.setValues((prev) => ({
      ...prev,
      signature_uuid: draft.signature_uuid ?? prev.signature_uuid,
      latitude: toStrOr(draft.latitude, prev.latitude),
      longitude: toStrOr(draft.longitude, prev.longitude),
      coordinate_capture_method: normalizeMethod(
        draft.coordinate_capture_method,
        prev.coordinate_capture_method
      ),
    }));

    setInitialLocationLoaded(true);
  }, []);

  useEffect(() => {
    console.log('[Formik] signature_uuid mudou →', formik.values.signature_uuid);
  }, [formik.values.signature_uuid]);

  useEffect(() => {
  }, [confirmBusy]);





  useEffect(() => {
    const t = setTimeout(() => {
      salvarDadosParciais({
        assinaturaCuffa: {
          ...formik.values,
          __savedAt: new Date().toISOString(),
        },
      });
    }, 500);
    return () => clearTimeout(t);
  }, [formik.values, salvarDadosParciais]);


  useEffect(() => {
    getLocation();
  }, []);

  return (
    <MenuProvider>
      <TopNavBar />
      <Header title="CUFFA - Assinatura e Geolocalização" showBackButton={true} />
      <Box width='97%' display='flex' flexDirection='column' alignItems='center' margin='2rem'>

        <ContainerForm
          title='1. Coordenadas Geográficas da Unidade'
          subtitle='Informe as coordenadas geográficas da localização da unidade.'
          width='1152px'
        >
          <Box display="flex" flexDirection="column" gap={3}>
            <FormControl>
              <FormLabel component="legend">
                <Typography variant="subtitle1" fontWeight="bold">
                  Método de captura das coordenadas *
                </Typography>
              </FormLabel>
              <RadioGroup
                value={formik.values.coordinate_capture_method}
                onChange={(e) => handleCoordinateMethodChange(e.target.value)}
              >
                <FormControlLabel
                  value={CoordinateCaptureMethodEnum.AUTOMATIC}
                  control={<Radio />}
                  label="Captura automática por GPS"
                />
                <FormControlLabel
                  value={CoordinateCaptureMethodEnum.MANUAL}
                  control={<Radio />}
                  label="Inserção manual"
                />
              </RadioGroup>
            </FormControl>

            {/* Campos de coordenadas */}
            {formik.values.coordinate_capture_method === CoordinateCaptureMethodEnum.MANUAL && (
              <Box display="flex" gap={2}>
                <InputComLabelFormik
                  formik={formik}
                  label="latitude"
                  labelTexto="Latitude (formato decimal)"
                  placeholder="Ex: -15.618889"
                  width="48%"
                  required
                  type="text"
                  mask="custom"
                  customMask={decimalMask}
                />
                <InputComLabelFormik
                  formik={formik}
                  label="longitude"
                  labelTexto="Longitude (formato decimal)"
                  placeholder="Ex: -56.097778"
                  width="48%"
                  required
                  type="text"
                  mask="custom"
                  customMask={decimalMask}
                />
              </Box>
            )}


            {formik.values.coordinate_capture_method === CoordinateCaptureMethodEnum.AUTOMATIC && initialLocationLoaded && (
              <Box>
                {haveCoords && (
                  <Typography variant="body2" color="textSecondary" mb={2}>
                    <strong>Coordenadas capturadas:</strong> {latNum.toFixed(6)}, {lngNum.toFixed(6)}
                  </Typography>
                )}
                <SimpleArcGISMap
                  center={haveCoords ? [lngNum, latNum] : [-56.0354, -15.5597]}
                  zoom={12}
                  height={400}
                  onPinLatLong={(lat, lng) => {
                    formik.setFieldValue('latitude', String(lat));
                    formik.setFieldValue('longitude', String(lng));
                  }}

                />
              </Box>
            )}


            <Alert severity="info">
              <Typography variant="body2">
                <strong>Formato aceito:</strong><br />
                • Decimal: -15.618889 / -56.097778<br />
              </Typography>
            </Alert>
          </Box>
        </ContainerForm>

        {/* Bloco 2: Assinatura Digital */}
        <ContainerForm
          title='2. Assinatura Digital'
          subtitle='Assine no campo abaixo para confirmar as informações.'
          width='1152px'
        >
          <Box display="flex" flexDirection="column" gap={3}>
            <Box>
              <FormLabel component="legend">
                <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                  Assinatura *
                </Typography>
              </FormLabel>
              <Typography variant="body2" color="textSecondary" mb={2}>
                Desenhe sua assinatura no campo abaixo usando o mouse ou touchscreen
              </Typography>
              <SignatureCanvas
                onSignatureUuidChange={handleSignatureUuidChange}
                error={formik.touched.signature_uuid && Boolean(formik.errors.signature_uuid)}
              />
              {formik.touched.signature_uuid && formik.errors.signature_uuid && (
                <Typography color="error" variant="caption" display="block" mt={1}>
                  {formik.errors.signature_uuid}
                </Typography>
              )}
            </Box>
          </Box>
        </ContainerForm>

        {/* Bloco 3: Ações */}
        <ContainerForm
          title='3. Finalizar Formulário'
          subtitle='Confirma que todos os dados estão corretos e deseja finalizar?'
          width='1152px'
        >
          <Box display="flex" gap={2} justifyContent="center">
            <Button
              variant="outlined"
              onClick={handleSaveDraft}
              sx={{ minWidth: '140px' }}
            >
              Salvar Rascunho
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmitForm}
              disabled={isSubmitDisabled}
              sx={{ minWidth: '120px' }}
            >
              {isSubmitting ? 'Enviando...' : 'Enviar Formulário'}
            </Button>


          </Box>
        </ContainerForm>

        <Box sx={{ mt: 3, alignSelf: 'center' }}>
          <Button
            variant="outlined"
            onClick={() => navigate(-1)}
            sx={{ minWidth: '120px' }}
          >
            Retornar
          </Button>
        </Box>
      </Box>

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={handleSnackClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MuiAlert elevation={6} variant="filled" onClose={handleSnackClose} severity={snack.severity}>
          {snack.message}
        </MuiAlert>
      </Snackbar>


      {/* Modal de Confirmação */}
      <Dialog open={showConfirmDialog} onClose={() => setShowConfirmDialog(false)}>
        <DialogTitle>⚠️ Confirmação de Envio</DialogTitle>
        <DialogContent>
          <Typography>
            Deseja realmente enviar o formulário?
            <br />
            Após o envio, não será mais possível editar os dados preenchidos.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowConfirmDialog(false)}>
            Cancelar
          </Button>
          <Button onClick={confirmSubmit} variant="contained" color="primary">
            Confirmar Envio
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de Sucesso */}
      <Dialog open={showSuccessDialog} onClose={() => setShowSuccessDialog(false)}>
        <DialogTitle sx={{ textAlign: 'center', color: 'success.main' }}>
          ✅ Sucesso!
        </DialogTitle>
        <DialogContent>
          <Typography variant="h6" textAlign="center" sx={{ mb: 2 }}>
            Formulário enviado com sucesso!
          </Typography>
          <Typography variant="body2" textAlign="center" color="text.secondary">
            Seus dados foram processados e enviados com sucesso.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button
            onClick={() => {
              setShowSuccessDialog(false);
              navigate('/cuffa');
            }}
            variant="contained"
            color="primary"
            sx={{ minWidth: '120px' }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de Erro */}
      <Dialog open={showErrorDialog} onClose={() => setShowErrorDialog(false)}>
        <DialogTitle sx={{ textAlign: 'center', color: 'error.main' }}>
          ⚠️ Erro ao enviar
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" textAlign="center">
            {errorMessage}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button
            onClick={() => setShowErrorDialog(false)}
            variant="contained"
            color="primary"
            sx={{ minWidth: '120px' }}
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </MenuProvider>
  );
};
